import {Component, OnInit} from '@angular/core';
import {PageComponent} from "../../../../../../core/shared/mvs-page/page.component";
import {ActivatedRoute} from "@angular/router";
import {MvsCoreService} from "../../../../../../core/shared/service/mvs-core.service";


@Component({
    selector: 'tm-tickets-page',
    templateUrl: 'tickets.page.html',
    styleUrls: ['tickets.page.css'],
    standalone: false
})
export class TicketsPage extends PageComponent implements OnInit {

  constructor(
    protected override route: ActivatedRoute,
    protected override coreService: MvsCoreService
  ) {
    super(route, coreService);
  }

  override ngOnInit() {
    super.ngOnInit();

    this.initComponent()

  }

  initComponent() {


    this.refreshComponent()
  }


  refreshComponent() {

    this.initialized = true;
  }

}
